import { isOfflineMailDataEnabled } from 'owa-offline-sync-feature-flags';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import isDeepLink from 'owa-url/lib/isDeepLink';

export function isOfflineMailComposeEnabled(mailboxInfo?: MailboxInfo): boolean {
    return (
        !isDeepLink() &&
        isGlobalFeatureEnabled('cmp-offline-mail-newdraft') &&
        isOfflineMailDataEnabled(mailboxInfo)
    );
}
